var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 11",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h2v4H0V0zM13 11h-2V7h2v4zM0 11V9h4v2H0zM13 0v2H9V0h4zM2 2V0h2v2H2zM11 9v2H9V9h2zM2 9H0V7h2v2zM11 2h2v2h-2V2z"
  })));
}
export default SvgFullscreen;